<template>
	<a
		v-if="product"
		href="javascript:void(0)"
		:class="[{'active':getCount}, classObject, class_css]"
		@click="eventHandler"
	>
		<svg v-html="iconHtml"></svg>
		<span v-if="title" v-html="title"></span>
	</a>
</template>

<script>
	import {Vue} from "ui.vue";
	import {store} from "citrus.vuex.store";
	import SITE_CONFIG from 'citrus.config';

	export default {
		name: "CitrusProductFavorites",
		store: store,
		props: {
			title: {
				type: [String, Boolean],
				default: false
			},
			class_css: {
				type: String,
				default: "productcard__first--favorite"
			},
			product: [Number, String],
			icon: {
				id: {
					type: String,
					default: "",
				},
				class_css: {
					type: String,
					default: "",
				}
			}
		},
		data: function () {
			return {

			};
		},
		computed: {
			loc() {
				return Object.freeze(Vue.getFilteredPhrases("CITRUS_VUE_PRODUCT_FAVORITES_"));
			},
			getCount: function() {
				return this.$store.getters['favorites/check'](this.product);
			},
			issetInList: function() {
				let isset = this.$store.getters['favorites/check'](this.product);
				return (isset > 0);
			},
			iconHtml: function() {
				return '<use x="0" y="0" xlink:href="' + SITE_CONFIG.SVG_PATH + '#' + this.icon.id + '" ></use>';
			}
		},
		mounted: function () {

		},
		beforeDestroy() {
			Vue.event.$off("Citrus.Vue.Favorites:remove:" + this.product);
			Vue.event.$off("Citrus.Vue.Favorites:check:" + this.product);
		},
		created: function() {
			Vue.event.$on("Citrus.Vue.Favorites:remove:" + this.product);
			Vue.event.$on("Citrus.Vue.Favorites:check:" + this.product);
		},
		updated: function () {},
		methods: {
			eventHandler: function() {
				if(this.issetInList)
					this.removeProduct();
				else
					this.addProduct();
			},
			addProduct: function() {
				this.$store.dispatch('favorites/add', this.product);
			},
			removeProduct: function() {
				this.$store.dispatch('favorites/remove', this.product);
			}
		}
	}
</script>